import { DictUtil } from 'jczh-ui'

// 公司类型
export const companyTypeDict = new DictUtil({
  ENTERPRISE: { value: 1, label: '企业' },
  PUBLIC_INSTITUTION: { value: 2, label: '事业单位' },
  SELF_EMPLOYEE: { value: 3, label: '个体工商户' },
  PERSON: { value: 4, label: '自然人' }
})

/**
 * 当前平台可开通的服务
 */
export const platformServiceDict = new DictUtil({
  PURCHASER: {
    value: 2,
    label: '采购人',
    desc: '发布企业自身采购或者招标项目',
    alias: 'purchaser',
    platformAlias: 'purchaser',
    certification: 'isPurchaser',
    iconName: 'purchaser',
    platform: 'ROLE_PURCHASER',
    companyType: [
      companyTypeDict.ENTERPRISE,
      companyTypeDict.PUBLIC_INSTITUTION
    ]
  },
  AGENCY: {
    value: 3,
    label: '代理机构',
    desc: '接受项目委托采购',
    alias: 'agency',
    platformAlias: 'agent',
    certification: 'isAgency',
    iconName: 'agency',
    platform: 'ROLE_AGENCY',
    companyType: [companyTypeDict.ENTERPRISE]
  },
  SUPPLIER: {
    value: 1,
    label: '供应商',
    desc: '参与投标报价',
    alias: 'supplier',
    platformAlias: 'supplier',
    certification: 'isSupplier',
    iconName: 'supplier',
    platform: 'ROLE_SUPPLIER',
    companyType: companyTypeDict.dictArray
  }
})

// 企业性质
export const companyNatureDict = new DictUtil({
  1: { value: 1, label: '国有独资企业' },
  2: { value: 2, label: '国有绝对控股企业' },
  3: { value: 3, label: '国有相对控股企业' },
  4: { value: 4, label: '港、澳、台投资企业' },
  5: { value: 5, label: '外商投资企业' },
  6: { value: 6, label: '公共管理和社会组织' },
  7: { value: 7, label: '私营企业' },
  // 8: { value: 8, label: '事业单位' },
  9: { value: 9, label: '军队' },
  10: { value: 10, label: '中外合资' },
  11: { value: 11, label: '其他' }
})

// 事业单位分类
export const publicInstitutionNatureDict = new DictUtil({
  1: { value: 1, label: '教育事业单位' },
  2: { value: 2, label: '科技事业单位' },
  3: { value: 3, label: '文化事业单位' },
  4: { value: 4, label: '卫生事业单位' },
  5: { value: 5, label: '社会福利事业单位' },
  6: { value: 6, label: '体育事业单位' },
  7: { value: 7, label: '交通事业单位' },
  8: { value: 8, label: '城市公用事业单位' },
  9: { value: 9, label: '农林牧渔水事业单位' },
  10: { value: 10, label: '信息咨询事业单位' },
  11: { value: 11, label: '中介服务事业单位' },
  12: { value: 12, label: '勘察设计事业单位' },
  13: { value: 13, label: '地震测防事业单位' },
  14: { value: 14, label: '海洋事业单位' },
  15: { value: 15, label: '环境保护事业单位' },
  16: { value: 16, label: '检验检测事业单位' },
  17: { value: 17, label: '知识产权事业单位' },
  18: { value: 18, label: '机关后勤服务事业单位' },
  19: { value: 19, label: '其它类' }
})
